import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { FormBuilder, Validators } from "@angular/forms";
import { AuditService } from "./core/_base/services/audit.service";

@Component({
  selector: "body[iRoute]",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "iRoute";

  ngOnInit(): void {

    /*
    Analizamos cambios con un observer para el DOM y poder capturar el texto mal inyectado de las librerías GTM y gtag
       IMPORTANTE:
       Este fragmento de código es solo para evitar la visualización de texto.
       Las librerías GTM y gtag capturan información para estadística y análisis de datos, debe de analizarse la cuenta que está
       sincronizada con este ID y ver cuál es el motivo por el cual se genera esta mala inyección. 
    */
    const observer = new MutationObserver(mutations => {
      mutations.forEach(m => {
        m.addedNodes.forEach(node => {
          if (node.nodeType === Node.TEXT_NODE && node.textContent?.includes('function')) { // Si el tipo de nodo es de tipo texto (3) y tiene la palabra function
            console.log('Texto detectado y removido:', node.textContent);
            node.parentNode?.removeChild(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

}

